import { render, staticRenderFns } from "./MspForsageDocs.vue?vue&type=template&id=2eb6480d&scoped=true&"
import script from "./MspForsageDocs.vue?vue&type=script&lang=js&"
export * from "./MspForsageDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb6480d",
  null
  
)

export default component.exports